import React from "react";
import Banner from "./Banner";
import Promotion from "../../layout/Promotion";
import StayTouch from "../../layout/StayTouch";
import AnyQuestions from "../../reusable/AnyQuestions";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class Sale extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <Promotion />
        <AnyQuestions />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Sale);



// WEBPACK FOOTER //
// ./src/pages/sale/index.js